import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { addLanguage, deleteLanguage, fetchLanguages, updateLanguage } from "./LanguageAPI";


const initialState = {
  data: [],
  loading: false,
  error: null,
};

export const fetchLanguagesAsync = createAsyncThunk(
  "Language/fetch",
  async (_, { rejectWithValue }) => {
    try {
      const data = await fetchLanguages();

      const resp = data.response;
      console.log("resp Language", resp)
      return await resp;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deleteLanguageAsync = createAsyncThunk(
  "Languages/delete",
  async ({uuid}) => {
    try {
      await deleteLanguage(uuid);
      return uuid;
    } catch (error) {
      // return rejectWithValue(error.message);
    }
  }
);

export const updateLanguageAsync = createAsyncThunk(
  "Languages/update",
  async ({ uuid, LanguageData }) => {
    try {
      const response = await updateLanguage( uuid, LanguageData);
      // console.log("Response Slice", response);
      return response;
    } catch (error) {
      // return rejectWithValue(error.message);
    }
  }
);

export const addLanguageAsync = createAsyncThunk(
  "Languages/add",
  async ({newLanguage}) => {
    try {
      const data = await addLanguage(newLanguage);
      // console.log("data in slice", data);
      return data;
    } catch (error) {
      console.log("errorL :", error);
      // return rejectWithValue(error.message);
    }
  }
);

const LanguageSlice = createSlice({
  name: "Language",
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchLanguagesAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchLanguagesAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // console.log("DAta", action.payload)
        state.error = null;
      })
      .addCase(fetchLanguagesAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      })
      
      .addCase(addLanguageAsync.fulfilled, (state, action) => {
        state.loading = false;
        if (Array.isArray(state.data)) {
          state.data?.push(action.payload);
        } else {
          state.data = [action.payload]; // Initialize as an array if it's not already
        }
      })
      .addCase(addLanguageAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error?.message || "Failed to add project";
      })

      .addCase(updateLanguageAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateLanguageAsync.fulfilled, (state, action) => {
        state.loading = false;
      
        if (Array.isArray(state.data)) {
          const updatedProjectIndex = state.data.findIndex(
            (LanguageData) => LanguageData.uuid === action.payload.uuid
          );
      
          if (updatedProjectIndex !== -1) {
            state.data[updatedProjectIndex] = action.payload;
          }
        } else {
          state.data = [action.payload];
        }
      })
      
      .addCase(updateLanguageAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error?.message || "Failed to update project";
      })
      
      .addCase(deleteLanguageAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteLanguageAsync.fulfilled, (state, action) => {
        state.loading = false;
        // Ensure state.data is an array before filtering
        if (Array.isArray(state.data)) {
          state.data = state.data.filter((Language) => Language.uuid !== action.payload);
        } else {
          console.error("state.data is not an array");
        }
      })
      .addCase(deleteLanguageAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const selectLanguages = (state) => state.language?.data?.candidate_languages;

export default LanguageSlice.reducer;
